/**
 * Event color utilities for provider progress display.
 */
import {
  type EventColorCategory,
  getEventDisplayConfig,
} from "@arti/dashboard-events";

import type { BudgetSeverity } from "./types";

import { COLOR_BG, COLOR_SOFT } from "../../common/colorTokens";

/**
 * Maps EventColorCategory to Tailwind CSS classes.
 * These are the actual styles applied to event icons in the dashboard.
 */
export const COLOR_CATEGORY_CLASSES: Record<EventColorCategory, string> = {
  amber: COLOR_SOFT.amber,
  blue: COLOR_SOFT.blue,
  cyan: COLOR_SOFT.cyan,
  emerald: COLOR_SOFT.emerald,
  gray: COLOR_SOFT.gray,
  green: COLOR_SOFT.green,
  indigo: COLOR_SOFT.indigo,
  purple: COLOR_SOFT.purple,
  red: COLOR_SOFT.red,
  rose: COLOR_SOFT.rose,
  sky: COLOR_SOFT.sky,
  slate: COLOR_SOFT.slate,
  violet: COLOR_SOFT.violet,
};

export const DEFAULT_COLOR_CLASS = COLOR_CATEGORY_CLASSES.gray;

export function getColorClassForEvent(eventType: string): string {
  const config = getEventDisplayConfig(eventType);
  if (!config) {
    return DEFAULT_COLOR_CLASS;
  }
  return COLOR_CATEGORY_CLASSES[config.color];
}

/** Maps budget severity to Tailwind color classes */
export const SEVERITY_COLORS: Record<
  BudgetSeverity,
  { bar: string; text: string; bg: string }
> = {
  critical: {
    bar: "bg-orange-500 dark:bg-orange-400",
    bg: COLOR_BG.orange,
    text: "text-orange-700 dark:text-orange-400",
  },
  exceeded: {
    bar: "bg-red-500 dark:bg-red-400",
    bg: COLOR_BG.red,
    text: "text-red-700 dark:text-red-400",
  },
  ok: {
    bar: "bg-green-500 dark:bg-green-400",
    bg: COLOR_BG.green,
    text: "text-green-700 dark:text-green-400",
  },
  warning: {
    bar: "bg-yellow-500 dark:bg-yellow-400",
    bg: COLOR_BG.yellow,
    text: "text-yellow-700 dark:text-yellow-400",
  },
};
